import { Directive, ElementRef, Renderer2, OnChanges, inject, input } from '@angular/core';

@Directive({
  selector: '[libReadMore]',
  standalone: true,
})
export class ReadMoreDirective implements OnChanges {
  readonly readMoreMaxSymbols = input.required<number>();
  readonly readMoreText = input<string>('See more');
  readonly seeLessText = input<string>('See less');

  private originalHtml = '';
  private expanded = false;
  private toggle: HTMLElement | null = null;

  readonly el = inject(ElementRef<HTMLElement>);
  readonly renderer = inject(Renderer2);

  ngOnChanges(): void {
    this.originalHtml = this.el.nativeElement.innerHTML || '';
    this.render();
  }

  private render(): void {
    const isTruncatable = this.originalHtml.length > this.readMoreMaxSymbols();
    const html =
      !this.expanded && isTruncatable
        ? this.originalHtml.substring(0, this.readMoreMaxSymbols()) + '...'
        : this.originalHtml;

    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', html);
    this.toggle = null;

    if (!isTruncatable) {
      return;
    }

    this.toggle = this.createToggle();
    this.renderer.appendChild(this.el.nativeElement, this.toggle);
  }

  private createToggle(): HTMLElement {
    const button = this.renderer.createElement('button');

    this.renderer.setAttribute(button, 'type', 'button');
    this.renderer.setAttribute(button, 'aria-expanded', String(this.expanded));
    this.renderer.addClass(button, 'read-more-toggle');
    this.renderer.setProperty(button, 'textContent', this.expanded ? this.seeLessText() : this.readMoreText());
    this.renderer.listen(button, 'click', () => {
      this.expanded = !this.expanded;
      this.render();
      // the toggle is recreated on every render — keep keyboard focus on it
      this.toggle?.focus();
    });

    return button;
  }
}
